import * as React from 'react';
import { WithTestId } from 'shared-client/types/test';
import { EntityDefinition } from 'types';
import { ViewSiteHost } from 'util/AppStateUtils';
import Alert from './Alert';
import { IsAbsoluteUrl } from './edit/fields/formatters';

interface ViewLiveModalProps extends WithTestId {
	record: any;
	sites: ViewSiteHost[];
	entityDefinition: EntityDefinition;
	isOpen: boolean;
	setModal: (isOpen: boolean) => void;
}

/**
 * Displays a modal with a list of sites that are scoped to the record that you are trying to view.
 * @param props
 */
function ViewLiveModal(props: ViewLiveModalProps) {
	const { entityDefinition, record, sites, isOpen, setModal, testId } = props;

	const recordName: string = record[entityDefinition.userFriendlyNameField]
		? record[entityDefinition.userFriendlyNameField]
		: record.name;

	return (
		<Alert
			renderTitle={() => <>View {entityDefinition.singularName}</>}
			isOpen={isOpen}
			onConfirm={() => setModal(false)}
			confirmButtonText="Close"
			color="primary"
			renderContents={() => (
				<>
					<p>On which site would you like to view &quot;{recordName}&quot;?</p>

					<div className="view-record__list">
						{sites.map((site, index) => (
							<div key={'site-' + record.url + '-' + site.name}>
								{site.name}
								<ul>
									{site.hosts?.map((siteHost) => (
										<li key={'site-' + record.url + '-' + siteHost}>
											<a
												href={IsAbsoluteUrl(record.url) ? record.url : siteHost + record.url}
												target="_blank"
												rel="noopener noreferrer"
												onClick={() => setModal(false)}
												data-testid={`${testId}-${index}`}
											>
												{siteHost}
											</a>
										</li>
									))}
								</ul>
							</div>
						))}
					</div>
				</>
			)}
		/>
	);
}

export default ViewLiveModal;
